import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const CreditsHistory = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [depositsData, setDepositsData] = useState([]);
  const [selectedTransactionType, setSelectedTransactionType] = useState("All");
  const [selectedUserFilter, setSelectedUserFilter] = useState("All"); // "by_me" or "by_others"

  const { id, role } = useParams(); // Extract ID and Role from URL
  const storedRole = localStorage.getItem("role");
  const storedUid = localStorage.getItem("uid");

  const userId = id || storedUid;
  const userRole = role || storedRole;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const url = `https://api.trubetx.com/admin/distributedCreditsToUsers/${userId}?transaction_type=${selectedTransactionType}&user_filter=${selectedUserFilter}`;

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setDepositsData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching data:", error.response?.data || error);
        setDepositsData([]);
      }
    };

    fetchData();
  }, [id, role, selectedTransactionType, selectedUserFilter]); // Re-fetch when filters change

  const filteredDeposits = depositsData.filter((deposit) => {
    return (
      deposit.receiver_id.toString().includes(searchTerm) ||
      deposit.distributor_id.toString().includes(searchTerm) ||
      deposit.receiver_role.toLowerCase().includes(searchTerm.toLowerCase()) ||
      deposit.distributor_role.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <div className="ml-0 lg:ml-[256px] z-0">
      {/* Header Section */}
      <div className="flex items-center justify-between p-4 bg-[#ffffff] rounded-t-lg mt-5">
        <h2 className="text-xl font-bold text-black">Credits History</h2>
        
        <div className="flex items-center space-x-4">
          {/* Transaction Type Dropdown */}
          <select
            className="bg-[#ffffff] text-black border rounded-lg p-2 focus:outline-none"
            value={selectedTransactionType}
            onChange={(e) => setSelectedTransactionType(e.target.value)}
          >
            <option value="All">All</option>
            <option value="bonus">Bonus</option>
            <option value="penalty">Penalty</option>
            <option value="received_payment">Deposits</option>
          </select>

          {/* By Me / By Others Dropdown */}
          <select
            className="bg-[#ffffff] text-black border rounded-lg p-2 focus:outline-none"
            value={selectedUserFilter}
            onChange={(e) => setSelectedUserFilter(e.target.value)}
          >
            <option value="All">All</option>
            <option value="by_me">By Me</option>
            <option value="by_others">By Others</option>
          </select>

          {/* Search Input */}
          <div className="">
            <input
              type="text"
              className="bg-[#ffffff] w-full pl-10 pr-4 py-2 rounded-lg border shadow-sm focus:outline-none text-black"
              placeholder="Search by ID or Role"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                className="h-5 w-5 text-gray-500"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Data Table */}
      <div className="overflow-x-auto custom-scrollbar  shadow-md sm:rounded-lg bg-[#ffffff]">
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-white uppercase bg-[#394a6a]">
            <tr>
              <th className="py-3 px-6">SNo.</th>
              <th className="py-3 px-6">Distributor ID</th>
              <th className="py-3 px-6">Distributor Role</th>
              <th className="py-3 px-6">Receiver ID</th>
              <th className="py-3 px-6">Receiver Role</th>
              <th className="py-3 px-6">Given Credit Tokens</th>
              <th className="py-3 px-6">Actual Given Money</th>
              <th className="py-3 px-6">Transaction Type</th>
              <th className="py-3 px-6">Add/Subtract</th>
              <th className="py-3 px-6">Transaction Date</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {filteredDeposits.map((deposit, index) => (
              <tr key={deposit.id} className="group bg-[#F9FAFB] border-b border-gray-200">
                <td className="text-black py-1 px-6">{index + 1}</td>
                <td className="text-black py-1 px-6">{deposit.distributor_id}</td>
                <td className="text-black py-1 px-6">{deposit.distributor_role}</td>
                <td className="text-black py-1 px-6">{deposit.receiver_id}</td>
                <td className="text-black py-1 px-6">{deposit.receiver_role}</td>
                <td className="text-black py-1 px-6">${deposit.given_credit_tokens.toFixed(1)}</td>
                <td className="text-black py-1 px-6">${deposit.actual_given_money.toFixed(1)}</td>
                <td className="text-black py-1 px-6 capitalize">{deposit.transaction_type}</td>
                <td className="text-black py-1 px-6 capitalize">{deposit.add_subtract}</td>
                <td className="text-black py-1 px-6">{new Date(deposit.transaction_date).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CreditsHistory;
